import React from "react";
import { formatDateTime } from "../lib/time";

const EventTable = ({
  events,
  editingCell,
  draftValue,
  onStartEdit,
  onDraftChange,
  onCommitEdit,
  onCancelEdit,
  onDeleteEvent,
}) => {
  const handleKeyDown = (event) => {
    if (event.key === "Enter") onCommitEdit();
    if (event.key === "Escape") onCancelEdit();
  };

  const renderCell = (row, field, { type = "text", mono = false } = {}) => {
    const isEditing =
      editingCell && editingCell.id === row.id && editingCell.field === field;

    if (isEditing) {
      return (
        <input
          type={type}
          value={draftValue}
          onChange={(e) => onDraftChange(e.target.value)}
          onBlur={onCommitEdit}
          onKeyDown={handleKeyDown}
          autoFocus
          onFocus={(e) => e.target.select()}
          step={type === "number" ? "0.01" : undefined}
          className={`w-full rounded border border-navy-600 bg-white px-1.5 py-0.5 text-sm focus:outline-none focus:ring-2 focus:ring-navy-600/20 ${
            mono ? "font-mono tabular-nums" : ""
          }`}
        />
      );
    }

    return (
      <div
        onClick={() => onStartEdit(row.id, field, row[field] || "")}
        className={`min-h-[1.5em] cursor-pointer rounded px-1 -mx-1 hover:bg-navy-50/60 ${
          mono ? "font-mono tabular-nums" : ""
        }`}
      >
        {row[field] !== undefined && row[field] !== null && row[field] !== ""
          ? row[field]
          : <span className="text-zinc-300">—</span>}
      </div>
    );
  };

  return (
    <section>
      <header className="mb-4 flex items-baseline justify-between">
        <span className="section-eyebrow">Events</span>
        <span className="text-xs text-zinc-500">
          {events.length} {events.length === 1 ? "entry" : "entries"}
        </span>
      </header>

      <div className="overflow-x-auto">
        <table className="table-hairline">
          <thead>
            <tr>
              <th className="w-16">Line</th>
              <th>Operation</th>
              <th className="text-right">Est. hrs</th>
              <th className="text-right">Actual hrs</th>
              <th>Start</th>
              <th>End</th>
              <th>Remarks</th>
              <th className="w-16 text-right" />
            </tr>
          </thead>
          <tbody>
            {events.length === 0 && (
              <tr>
                <td
                  colSpan={8}
                  className="py-10 text-center text-sm text-zinc-400"
                >
                  No events yet. Add one above.
                </td>
              </tr>
            )}
            {events.map((event) => (
              <tr key={event.id}>
                <td className="num">{renderCell(event, "line", { mono: true })}</td>
                <td>{renderCell(event, "operation")}</td>
                <td className="text-right num">
                  {renderCell(event, "estimatedHours", { type: "number", mono: true })}
                </td>
                <td className="text-right num">
                  {renderCell(event, "actualHours", { type: "number", mono: true })}
                </td>
                <td className="num text-zinc-600">{formatDateTime(event.startAt) || <span className="text-zinc-300">—</span>}</td>
                <td className="num text-zinc-600">{formatDateTime(event.endAt) || <span className="text-zinc-300">—</span>}</td>
                <td>{renderCell(event, "remarks")}</td>
                <td className="text-right">
                  <button
                    type="button"
                    className="text-xs font-medium text-zinc-400 hover:text-rust-600"
                    onClick={() => onDeleteEvent(event.id)}
                  >
                    Delete
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </section>
  );
};

export default React.memo(EventTable);
